
import Vue, { PropType } from 'vue';
import { getOWCasinoId } from '@/services/gameLauncher';

interface OWFile {
  gameId?: string;
  url?: string;
  launchProvider?: string;
}

export default Vue.extend({
  name: 'OWLaunchModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    file: {
      type: Object as PropType<OWFile | null>,
      default: null,
    },
  },
  data() {
    return {
      pendingResolve: null as null | (({ url, launchGameData }: { url: string; launchGameData: any }) => void),
      pendingReject: null as null | ((err: Error) => void),
    };
  },
  methods: {
    onMessage(event: MessageEvent) {
      if (!event.data || typeof event.data !== 'object') return;
      switch (event.data.action) {
        case 'launch-result':
          if (this.pendingResolve) {
            this.pendingResolve({ url: event.data.url, launchGameData: event.data.launchGameData });
            this.pendingResolve = null;
            this.pendingReject = null;
          }
          break;
        case 'launch-error':
          if (this.pendingReject) {
            this.pendingReject(new Error(event.data.error));
            this.pendingResolve = null;
            this.pendingReject = null;
          }
          break;
      }
    },

    launchViaIframe(
      gameId: string,
      gameUrl?: string,
      casinoId?: number
    ): Promise<{ url: string; launchGameData: any }> {
      return new Promise((resolve, reject) => {
        const iframe = (this.$refs.launcherFrame as HTMLIFrameElement)?.contentWindow;
        if (!iframe) {
          reject(new Error('Launcher iframe not available'));
          return;
        }
        this.pendingResolve = resolve;
        this.pendingReject = reject;
        iframe.postMessage({ action: 'launch', gameId, gameUrl, casinoId }, '*');
      });
    },

    async confirm() {
      const file = this.file;
      if (!file?.gameId) {
        this.$emit('done');
        return;
      }

      const casinoId = getOWCasinoId(file.gameId);
      try {
        const { url } = await this.launchViaIframe(file.gameId, file.url, casinoId);
        const win = window.open(url, '_blank');
        if (!win) {
          this.$toast.error('Pop-up was blocked. Please allow pop-ups for this site.');
        }
      } catch (e: any) {
        this.$toast.error(e?.message || 'Game unavailable');
      } finally {
        this.$emit('done');
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },
});
